/**
 * Page Format Configuration
 * Defines standard paper sizes and canvas dimensions
 */

// Page formats in mm (then converted to pixels for canvas)
// Using 96 DPI for screen display: 1mm = 3.78 pixels
const MM_TO_PX = 3.78;

export const PAGE_FORMATS = {
  A3: {
    id: "A3",
    label: "A3",
    width: 297,  // mm
    height: 420, // mm
    widthPx: Math.round(297 * MM_TO_PX),
    heightPx: Math.round(420 * MM_TO_PX),
  },
  A4: {
    id: "A4",
    label: "A4",
    width: 210,
    height: 297,
    widthPx: Math.round(210 * MM_TO_PX),
    heightPx: Math.round(297 * MM_TO_PX),
  },
  A5: {
    id: "A5",
    label: "A5",
    width: 148,
    height: 210,
    widthPx: Math.round(148 * MM_TO_PX),
    heightPx: Math.round(210 * MM_TO_PX),
  },
  A6: {
    id: "A6",
    label: "A6",
    width: 105,
    height: 148,
    widthPx: Math.round(105 * MM_TO_PX),
    heightPx: Math.round(148 * MM_TO_PX),
  },
  CUSTOM: {
    id: "CUSTOM",
    label: "Personnalise",
    width: 210,
    height: 297,
    widthPx: Math.round(210 * MM_TO_PX),
    heightPx: Math.round(297 * MM_TO_PX),
  },
};

export const ORIENTATIONS = {
  PORTRAIT: "portrait",
  LANDSCAPE: "landscape",
};

// Get dimensions based on format and orientation
export function getPageDimensions(formatId, orientation = ORIENTATIONS.PORTRAIT) {
  const format = PAGE_FORMATS[formatId] || PAGE_FORMATS.A4;
  
  if (orientation === ORIENTATIONS.LANDSCAPE) {
    return {
      width: format.heightPx,
      height: format.widthPx,
      widthMm: format.height,
      heightMm: format.width,
    };
  }
  
  return {
    width: format.widthPx,
    height: format.heightPx,
    widthMm: format.width,
    heightMm: format.height,
  };
}

// Scale dimensions to fit container while maintaining aspect ratio
export function getScaledDimensions(pageWidth, pageHeight, containerWidth, containerHeight, padding = 40) {
  const availableWidth = containerWidth - padding * 2;
  const availableHeight = containerHeight - padding * 2;
  
  const scaleX = availableWidth / pageWidth;
  const scaleY = availableHeight / pageHeight;
  const scale = Math.min(scaleX, scaleY, 1.5); // Max 150% zoom
  
  return {
    width: pageWidth * scale,
    height: pageHeight * scale,
    scale,
  };
}

// Export grouping configurations
export const EXPORT_GROUPINGS = [
  { id: 1, label: "1 par page", cols: 1, rows: 1 },
  { id: 2, label: "2 par page", cols: 1, rows: 2 },
  { id: 4, label: "4 par page", cols: 2, rows: 2 },
  { id: 8, label: "8 par page", cols: 2, rows: 4 },
  { id: 16, label: "16 par page", cols: 4, rows: 4 },
];

// Calculate positions for grouped exports
export function getGroupedPositions(grouping, pageWidth, pageHeight, padding = 10) {
  const config = EXPORT_GROUPINGS.find(g => g.id === grouping) || EXPORT_GROUPINGS[0];
  const cellWidth = (pageWidth - padding * (config.cols + 1)) / config.cols;
  const cellHeight = (pageHeight - padding * (config.rows + 1)) / config.rows;
  
  const positions = [];
  for (let row = 0; row < config.rows; row++) {
    for (let col = 0; col < config.cols; col++) {
      positions.push({
        x: padding + col * (cellWidth + padding),
        y: padding + row * (cellHeight + padding),
        width: cellWidth,
        height: cellHeight,
        scale: Math.min(cellWidth / pageWidth, cellHeight / pageHeight),
      });
    }
  }
  
  return positions;
}

export default {
  PAGE_FORMATS,
  ORIENTATIONS,
  getPageDimensions,
  getScaledDimensions,
  EXPORT_GROUPINGS,
  getGroupedPositions,
};
